export function getErrorMessageFromAws(responseType: string) {
  switch (responseType) {
    case "DEFAULT_4XX":
      return "Ocurrió un error del navegador (4XX). Por favor, verifica la solicitud y vuelve a intentarlo.";
    case "DEFAULT_5XX":
      return "Ocurrió un error del servidor (5XX). Por favor, intenta nuevamente más tarde.";
    case "RESOURCE_NOT_FOUND":
      return "El recurso solicitado no fue encontrado. Verifica la URL o el identificador del recurso.";
    case "UNAUTHORIZED":
      return "No autorizado. Por favor, asegúrate de que tienes las credenciales correctas para acceder a este recurso.";
    case "INVALID_API_KEY":
      return "Clave API inválida. Verifica que la clave utilizada sea correcta y válida.";
    case "ACCESS_DENIED":
      return "Acceso denegado. No tienes los permisos necesarios para acceder a este recurso.";
    case "AUTHORIZER_FAILURE":
      return "Error del autorizador. No se pudo completar el proceso de autorización.";
    case "AUTHORIZER_CONFIGURATION_ERROR":
      return "Error en la configuración del autorizador. Por favor, contacta al administrador del sistema.";
    case "INVALID_SIGNATURE":
      return "Firma inválida. Verifica que la solicitud esté firmada correctamente.";
    case "EXPIRED_TOKEN":
      return "El token ha expirado. Por favor, genera un nuevo token e inténtalo nuevamente.";
    case "MISSING_AUTHENTICATION_TOKEN":
      return "Falta el token de autenticación. Asegúrate de incluir un token válido en tu solicitud.";
    case "INTEGRATION_FAILURE":
      return "Fallo en la integración. No se pudo completar la solicitud con el servicio de integración.";
    case "INTEGRATION_TIMEOUT":
      return "Tiempo de espera agotado en la integración. El servicio de integración no respondió a tiempo.";
    case "API_CONFIGURATION_ERROR":
      return "Error en la configuración de la API. Contacta al administrador del sistema para resolver el problema.";
    case "UNSUPPORTED_MEDIA_TYPE":
      return "Tipo de medio no soportado. Verifica que el formato de los datos enviados sea válido.";
    case "BAD_REQUEST_PARAMETERS":
      return "Parámetros de la solicitud inválidos. Verifica que los datos enviados sean correctos.";
    case "BAD_REQUEST_BODY":
      return "El cuerpo de la solicitud es inválido. Asegúrate de enviar datos en el formato correcto.";
    case "REQUEST_TOO_LARGE":
      return "La solicitud es demasiado grande. Reduce el tamaño de los datos enviados.";
    case "THROTTLED":
      return "La solicitud fue limitada. Has excedido el número máximo de solicitudes permitidas. Intenta más tarde.";
    case "QUOTA_EXCEEDED":
      return "Se ha excedido la cuota asignada. Por favor, revisa tus límites y ajusta tus solicitudes.";
    case "WAF_FILTERED":
      return "La solicitud fue bloqueada por el firewall de aplicaciones web (WAF). Verifica que no estés enviando datos prohibidos.";
    default:
      return "Error desconocido. Por favor, contacta al soporte.";
  }
}
